import classNames from "../../lib/classnames";
import PropTypes from "prop-types";
import React from "react";
import styles from "./Container.module.css";

export default function Container(props) {
    return <div className={classNames(styles.container, props.className)}>{props.children}</div>;
}

Container.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
